export default __webpack_public_path__ + "images/membership-letter.933d47e28db4c31a9b0f5934d78e7aff.png";